/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback,  useEffect, useState } from "react";
import { Spin } from "antd";
import { ContentSection } from "./components/ContentSection";
import { useDispatch, useSelector } from "react-redux";
import { State } from "../../../model/application/state";
import { UserAuthentication } from "../../../service/action/merchant";
import { URLSearch } from "./../../../shared/component/urlSearch";
import { LoadingOutlined } from "@ant-design/icons";
import MerchantPortalAuthenticator from 'xpress_merchant_authenticator'

const antIcon = <LoadingOutlined style={{ fontSize: 50 }} spin rev={undefined} />;

export const HomePage: React.FC = () => {
  const dispatch = useDispatch();
  const { merchantLandingPage }: any = useSelector((state) => state);

  const merchantLandingState_: State.UserValidation = merchantLandingPage;

  const appUrlToken = URLSearch.getParameterByName("tk").replace(/\s/g, "");
  const merchantPortalDomain = localStorage.getItem("$$$$") ?? ''

  const [loading, setLoading] = useState(merchantLandingState_.isProcessing || false)

  const authenticateUser = useCallback(
    (token: string) => {
      // toggle loading state to true when authentication starts
      setLoading(true)

      dispatch({
        type: UserAuthentication.GET_USER_AUTHENTICATION,
        payload: {
          ...merchantLandingState_,
          isProcessing: loading,
          ssoDomain: merchantPortalDomain,
          token,
          showMobileMenu: false
        },
      });
    },
    [merchantLandingState_, merchantPortalDomain]
  );

  const validateUser = useCallback(
    () => {
      if(appUrlToken) {
        authenticateUser(appUrlToken)

        return
      } 
      
      // listen for the token from the authenticator
      MerchantPortalAuthenticator.getToken({
        appKey: merchantPortalDomain, // merchant portal URL
        onError: (error) => {
          setLoading(false)
          console.error("Error getting token:", error);
        },
        onSuccess: (token) => authenticateUser(token) // authenticate user
      })
    },
    []
  );

  useEffect(validateUser, []);

  // useEffect(() => {
  //   const token = appUrlToken ?? authenticatorToken
    
  //   if(token) authenticateUser(token)
  // }, [appUrlToken, authenticatorToken]);

  return (
      <Spin
        spinning={loading}
        size="large"
        indicator={antIcon}
        style={{
          color: "green",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: 100,
        }}
      >
        <ContentSection />
      </Spin>
  );
};